import { defineStore } from "pinia";
import { ref } from "vue";
import axios from "axios";
import router from "@/router";

export const useAuthStore = defineStore("auth", () => {
  const token = ref(localStorage.getItem("token"));
  const user = ref(JSON.parse(localStorage.getItem("user")));
  const selectedCompany = ref(JSON.parse(localStorage.getItem("company")));

  // const API_URL = "http://localhost/carcu-backend/api/endpoints/";
  const API_URL = "https://carcu.com.mx/carcu-backend/api/endpoints/";

  async function login(username, password) {
    try {
      const { data } = await axios.post(
        API_URL + "login.php",
        {
          username,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log({ data });
      token.value = data.token;
      // Aquí decodificaríamos el token para obtener los datos del usuario
      // const decodedToken = JSON.parse(atob(data.token.split(".")[1]));
      user.value = {
        id: data.user.id,
        nombre: data.user.nombre,
        username: data.user.username,
        // Agrega otros campos que necesites del token
      };
      // console.log("Usuario autenticado:", user.value);
      // user.value = { nombre: "Usuario Demo" };
      localStorage.setItem("token", token.value);
      localStorage.setItem("user", JSON.stringify(user.value));
      router.push("/seleccionar-empresa");
    } catch (error) {
      console.error("Error en login:", error);
      throw new Error("Usuario o contraseña incorrectos");
    }
  }

  async function getEmpresas() {
    try {
      const { data } = await axios.get(API_URL + "empresas.php", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.value}`, // Include the token here
        },
      });
      // console.log({ empresas: data.empresas, data });

      return data.empresas; // Asegúrate de que la respuesta tenga un campo 'empresas'
    } catch (error) {
      console.error("Error en al obtener las empresas:", error);
      throw new Error("No se pudieron cargar las empresas");
    }
  }

  async function cambiarEmpresa() {
    selectedCompany.value = null;
    localStorage.removeItem("company");
    router.push("/seleccionar-empresa");
  }

  function selectCompany(company) {
    selectedCompany.value = company;
    localStorage.setItem("company", JSON.stringify(company));
    router.push("/dashboard");
  }

  function logout() {
    token.value = null;
    user.value = null;
    selectedCompany.value = null;
    localStorage.clear();
    router.push("/login");
  }

  return {
    token,
    user,
    selectedCompany,
    login,
    selectCompany,
    logout,
    getEmpresas,
    cambiarEmpresa,
  };
});
